<template>
  <yioks-tutorial @back="goBack">
    <template slot="navLeftBtns">
      <div class="btn " v-if="false">资源库</div>
      <div class="btn active"
           @click="other_tutorial(0)">学员共享</div>
      <div class="btn"
           @click="other_tutorial(1)">我的教案</div>
    </template>
    <template slot="navRightBtns">
      <div class="btn active"
           @click="createTutorial('practice')">创建实践教案</div>
      <div class="btn active"
           @click="createTutorial('exam')">创建考试教案</div>
    </template>
  </yioks-tutorial>
</template>

<script>
  export default {
    name: "tutorial-official",
    data() {
      return {
        c_id: this.$route.query.c_id,
      };
    },
    components: {
      "yioks-tutorial": ()=>import("@/components/Tutorial/tutorial-resource"),
    },
    methods: {
      goBack() {
        this.$router.push({
          path: "class_detail",
          query: {}
        });
      },
      other_tutorial(type) {
        this.$router.replace({
          path: "tutorial_other",
          query: {
            res_type: type
          }
        });
      },
      createTutorial(type) {
        this.$router.push({path: "create_tutorial", query: {session_type: type, c_id: this.c_id}});
      },
    }
  }
</script>
